const imports = [
    { selector: "#engi_doc_create", module: () => require('../doc/create/doc_create.js') },
    { selector: "#engineer_doc_edit", module: () => require('../doc/edit/doc_edit.js') },
];

imports.forEach(item => {
    if ($(item.selector).length > 0) {
        item.module();
    }
});
